export default class MessagesActionDialog {
  displayDialog: boolean;
  title: string;
  discussionId?: string;
  prospectId?: string;
  loadUnseenDiscussions: boolean;
  displaySeenChecks: boolean;

  constructor() {
    this.displayDialog = false;
    this.title = "";
    this.discussionId = "";
    this.prospectId = "";
    this.loadUnseenDiscussions = false;
    this.displaySeenChecks = false;
  }
}
